import {type ColumnKey, useBoardColumn} from '@github-ui/board-core'
import {clsx} from 'clsx'
import type {ReactNode} from 'react'

import styles from './BoardColumnFrame.module.css'

export type BoardColumnFrameProps = {
  columnKey: ColumnKey
  /** The column's header. Typically a `BoardColumnHeader`. */
  children?: ReactNode
  className?: string
}

/**
 * A column's shell in the header strip: its width, and the slot its header sits in.
 *
 * The headers sit outside the rows because a column spans every row, so its header
 * cannot live inside one of them. On a board with no swimlane that degenerates to the
 * familiar picture: one row, so the header sits directly above its only cell.
 */
export function BoardColumnFrame({columnKey, children, className}: BoardColumnFrameProps) {
  const {columnProps} = useBoardColumn(columnKey)

  return (
    <div {...columnProps} className={clsx(styles.ColumnFrame, className)}>
      {children}
    </div>
  )
}
